import { type TabBarItem } from '@/designs-dev/device/TabBar';
import ArchitectureActions from '@/karehero-app/architecture/ArchitectureActions';
import ArchitectureApp from '@/karehero-app/architecture/ArchitectureApp';
import ArchitectureCare from '@/karehero-app/architecture/ArchitectureCare';
import ArchitectureHelp from '@/karehero-app/architecture/ArchitectureHelp';
import ArchitectureHome from '@/karehero-app/architecture/ArchitectureHome';
import TabPlaceholder from '@/karehero-app/shell/TabPlaceholder';

// Four tabs: Profile has gone into Care.
const TABS: TabBarItem[] = [
  { id: 'home', label: 'Home', icon: 'house', solid: true },
  { id: 'actions', label: 'Actions', icon: 'calendar', solid: true },
  { id: 'care', label: 'Care', icon: 'heart', solid: true },
  { id: 'help', label: 'Help', icon: 'circle-question', solid: false },
];

// PROPOSED. The architecture cut with Care and Profile as one tab, and the app
// about one person at a time.
//
// Switching person in the bar switches every tab, not only the name: with an
// assistant in the app, which person a question is about has to be the one
// thing that is never ambiguous. Each tab is keyed by the person, so it starts
// afresh on whoever was picked.
const ArchitectureCareApp = () => (
  <ArchitectureApp
    cut={{
      tabs: TABS,
      assessTab: 'care',
      screen: (tab, { person, setPerson, setTab, setIntro, assessKey }) =>
        tab === 'home' ? (
          <ArchitectureHome
            key={person}
            person={person}
            onSwitch={setPerson}
            onCard={setIntro}
          />
        ) : tab === 'actions' ? (
          <ArchitectureActions
            key={person}
            title={person}
            onSwitch={setPerson}
          />
        ) : tab === 'care' ? (
          <ArchitectureCare
            key={`${person}-${assessKey}`}
            person={person}
            onSwitch={setPerson}
          />
        ) : tab === 'help' ? (
          <ArchitectureHelp
            key={person}
            title={person}
            onSwitch={setPerson}
            onTalk={() => setTab('chat')}
          />
        ) : (
          <TabPlaceholder title='Chat' />
        ),
    }}
  />
);

export default ArchitectureCareApp;
